import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/system';

import GlobalHeader from '../../components/GlobalHeader';
import PaddedContainer from '../../components/PaddedContainer ';
import { SLPArtistsHero } from './SLPArtistsHero';
import SLPArtistsWhy from './SLPArtistsWhy';
import { SLPArtistsHow } from './SLPArtistsHow';
//import SLPArtistsUserReview from './SLPArtistsUserReview';
import BannerImage from '../../assets/banner.png';
import Button from '../components/Button';
import SLPArtistsListArtstyleButton from './SLPArtistsListArtstyleButton';
import SLPFooter from '../components/SLPFooter';

const SLPArtists = () => {
  const theme = useTheme();
  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div className="overflow-hidden bg-green cursor-default">
      <GlobalHeader />
      {/* Hero section */}

      <PaddedContainer className="">
        <SLPArtistsHero />
      </PaddedContainer>
      <Box id="what-makes-saagas-different">
        <PaddedContainer>
          <SLPArtistsWhy />
        </PaddedContainer>
      </Box>
      <PaddedContainer>
        <Box
          // sx={{ marginBottom: { xs: '2rem', md: '100px' } }}       //remove comment when Insights section is back
        >
          <SLPArtistsHow />
        </Box>
      </PaddedContainer>

      {/* <PaddedContainer bgColor="linear-gradient(195.36deg, rgba(16, 166, 202, 0.2) -110.46%, rgba(86, 20, 110, 0.2) 100%)">
        <Box
          // className="max-w-[1256px] m-auto relative mt-[120px]"
          sx={{
            maxWidth: '1256px',
            margin: 'auto',
            position: 'relative',
            mt: { sm: 0, md: '120px' } // or use number: mt: 15 if you're using theme.spacing
          }}
        >
          <SLPArtistsUserReview />
        </Box>
      </PaddedContainer> */}
      <PaddedContainer>
        <Box
          sx={{
            overflow: 'hidden',
            width: '100%',
            height: {
              xs: '507px',
              md: '507px',
              lg: '422px'
            },
            backgroundImage: `url(${BannerImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            // marginTop: '1rem'              //remove comment when Insights section is back        
          }}
        >
          <Box sx={{ textAlign: 'center', mt: '3.75rem' }}>
            <Typography
              fontFamily="Inter"
              sx={{
                fontFamily: 'Inter',
                fontWeight: 700,
                fontSize: '40px',
                lineHeight: '100%',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFF'
              }}
            >
              Join UGC Creators and Brands
            </Typography>

            <Typography
              fontFamily="Inter"
              sx={{
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: { xs: '20px', sm: '20px', md: '24px', lg: '24px' },
                lineHeight: '100%',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFFCC',
                mt: 2,
                mb: { xs: '15px', sm: '15px', md: '0px', lg: '0px' },
                mx: { xs: '15px', sm: '15px', md: '0px', lg: '0px' }
              }}
            >
              who trust us to manage their UGC licensing needs
            </Typography>

            <Button
              as="a"
              href="https://t.co/401XPwdXQx"
              target="_blank"
              rel="noreferrer"
              variant="primary"
              style={{
                border: '1px solid #FAFAFA',
                backgroundColor: 'transparent',
                width: '206px',
                maxHeight: '60px',
                borderRadius: '30px',
                padding: '18px 16px',
                color: '#FAFAFA',
                fontWeight: 700,
                fontSize: '20px',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textDecoration: 'none',
                margin: '2rem auto 0'
              }}
            >
              Join our discord
            </Button>
          </Box>
        </Box>
      </PaddedContainer>
      {/* FAQ */}
      <PaddedContainer>
        <Box
          component="section"
          sx={{
            pt: { xs: '2.5rem', md: '3rem' },
            px: { xs: '1rem', md: '0' }
          }}
        >
          <Typography
            fontFamily="Inter"
            
            sx={{
              fontFamily: 'Inter',
              fontWeight: 400,
              fontSize: { xs: '1.25rem', md: '30px' },
              lineHeight: '122%',
              letterSpacing: '0px',
              textAlign: 'center',
              verticalAlign: 'middle',
              color: '#FFFFFFCC',
              opacity: 1
            }}
          >
            Visit our FAQs page for more information
          </Typography>
          <Link to="/faq">
            <Button
              as="a"
              href="/faq"
              target="_blank"
              rel="noreferrer"
              variant="primary"
              className="
                font-[500] 
                text-[16.8px]
                border border-[#FAFAFA]
                bg-transparent
                max-w-[100px] max-h-[60px]
                rounded-[30px]
                px-[24px] py-[20px]
                text-[#FAFAFA]
                text-center
                flex justify-center items-center
                no-underline
                mt-3 mx-auto mb-16
                font-inter
              "
            >
              FAQs
            </Button>
          </Link>
        </Box>
      </PaddedContainer>
      <PaddedContainer>
        <Box sx={{ textAlign: 'center', mt: 5, pb: { xs: '2rem', md: '0', lg: '4rem' }, pl: { sm: '16px' }, pr: { sm: '16px' } }}>
          <Box sx={{ pl: { xs: '16px' }, pr: { xs: '16px' }, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography
              fontFamily="Inter"
              component="h3"
              variant="h3"
              sx={{
                fontFamily: 'Inter',
                fontWeight: 700,
                fontSize: { xs: '24px', md: '40px' },
                lineHeight: '100%',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFF'
              }}
            >
              Express Yourself
            </Typography>
            <Typography
              component="p"
              fontFamily="Inter"
              sx={{
                mt: 2,
                fontFamily: 'Inter',
                fontWeight: { xs: 500, md: 400 },
                fontSize: { xs: '16px', md: '24px' },
                lineHeight: '122%',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFFCC',
              }}
            >
              While upholding the value of human artistry in the age of AI
            </Typography>
            <Box sx={{ width: { xs: '164px', md: '200px' }, mt: { xs: '4px' } }}>
              <SLPArtistsListArtstyleButton
                maxWidth={isMdOrBelow ? '131px' : '200px'}
                maxHeight={isMdOrBelow ? '49px' : '52px'}
                fontSize={isMdOrBelow ? '14px' : '16px'}
                padding={isMdOrBelow ? '8px 15px' : '16px 32px'}
                marginTop={{ xs: '36px', sm: '40px' }}
              />
            </Box>
          </Box>
        </Box>
      </PaddedContainer>
      <PaddedContainer>
        <Box sx={{ display: 'flex', justifyContent: 'center', pb: { xs: '2rem', md: '4rem' } }}>
          <Link to="/pricing" style={{ textDecoration: 'none' }}>
            <Box
              component="button"
              sx={{
                px: { xs: 3, md: 5 },
                py: { xs: 1.25, md: 1.75 },
                borderRadius: '170px',
                boxShadow: '0px -4px 50px 0px rgba(11,87,208,0.68)',
                fontWeight: 700,
                fontSize: { xs: '14px', md: '16px' },
                background: 'linear-gradient(163deg, rgb(12, 174, 207) -29.1%, rgb(88, 15, 107) 96.45%)',
                color: 'white',
                fontFamily: 'Inter',
                border: 'none',
                cursor: 'pointer',
                textTransform: 'none',
                '&:hover': {
                  background: 'linear-gradient(163deg, rgb(12, 160, 200) -29.1%, rgb(80, 10, 100) 96.45%)'
                }
              }}
            >
              View Pricing Plans →
            </Box>
          </Link>
        </Box>
      </PaddedContainer>
      <PaddedContainer>
        <SLPFooter />
      </PaddedContainer>
    </div>
  );
};

export default SLPArtists;
